// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewControls_wrapper__jUbpi"};